<template>
	<div class="tournament">
		<SubHeader
			title="JDO Tournament Prize Winner"
			subtitle="JDOトーナメント入賞者"
		/>

		<div class="container">
			<ul class="nav nav-pills mb-3" id="myTab" role="tablist">
				<li class="nav-item">
					<a class="nav-link active" href="javascript:void(0);"> 2026年度 </a>
				</li>
				<li class="nav-item">
					<a class="nav-link" href="/jdo/tournament2025"> 2025年度 </a>
				</li>
				<li class="nav-item">
					<a class="nav-link" href="/jdo/tournament2024"> 2024年度 </a>
				</li>
				<li class="nav-item">
					<a class="nav-link" href="/jdo/tournament2023"> 2023年度 </a>
				</li>
				<li class="nav-item">
					<a class="nav-link" href="/jdo/tournament2022"> 2022年度 </a>
				</li>
			</ul>

			<div id="20261025_okayama" class="row mb-4">
				<div class="col-12">
					<h4>2026.10.25 OKAYAMA OPEN DARTS TOURNAMENT 2026</h4>
				</div>
				<div class="col-12 mb-4 row">
					<div class="col-lg-5 text-center mx-auto">
						<p>
							<span class="rank">3位タイ</span>
							<img
								src="/images/jdo/2026/okayama/okayama_01.jpg"
								class="img-fluid"
							/>
							<span class="name">工藤 光生・石倉 華令良</span>
						</p>
					</div>
				</div>
			</div>

			<div id="20261010_interleague" class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>2026.10.10 JDO INTERLEAGUE CHAMPIONSHIP 2026</h4>
				</div>
				<div class="col-12 mb-4 row">
					<div class="col-lg-5 text-center mx-auto">
						<p>
							<span class="rank">3位タイ</span>
							<img
								src="/images/jdo/2026/interleague/just.jpg"
								class="img-fluid"
							/>
							<span class="name"
								>JUST<br />（角家 元二、倉戸 亮、田原 駿也、西本 陽一、石井
								庸介、Paul Winterburn、浅田 斉吾、山下 竜起、柴田 豊和）</span
							>
						</p>
					</div>
				</div>
			</div>

			<div id="20260830_hiroshima" class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>2026.8.30 第18回 広島ダーツオーガニゼーション大会</h4>
				</div>
				<div class="row mb-4">
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">オープンダブルス 優勝</span>
							<img
								src="/images/jdo/2026/hiroshima/hiroshima_01.jpg"
								class="img-fluid"
							/>
							<span class="name">高山 得溶・大本 直樹</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">レディースシングルス 3位タイ</span>
							<img
								src="/images/jdo/2026/hiroshima/hiroshima_03.jpg"
								class="img-fluid"
							/>
							<span class="name">青木 まゆ</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">メンズシングルス 優勝</span>
							<img
								src="/images/jdo/2026/hiroshima/hiroshima_02.jpg"
								class="img-fluid"
							/>
							<span class="name">高山 得溶</span>
						</p>
					</div>
				</div>
			</div>

			<div id="20260720_hyogo" class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>2026.7.20 第35回 H.D.O.オープンダーツトーナメント大会</h4>
				</div>
				<div class="row mb-4">
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">オープンダブルス 準優勝</span>
							<img
								src="/images/jdo/2026/hyogo/hyogo_01.jpg"
								class="img-fluid"
							/>
							<span class="name">柳瀬 将一・大本 直樹</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">レディースシングルス 準優勝</span>
							<img
								src="/images/jdo/2026/hyogo/hyogo_02.jpg"
								class="img-fluid"
							/>
							<span class="name">青木 まゆ</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">メンズシングルス 準優勝</span>
							<img
								src="/images/jdo/2026/hyogo/hyogo_03.jpg"
								class="img-fluid"
							/>
							<span class="name">黒川 智成</span>
						</p>
					</div>
				</div>
			</div>

			<div id="20260719_jdomasters" class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>2026.07.19 JDO MASTER'S 2026</h4>
				</div>
				<div class="col-12 mb-4 row">
					<div class="col-lg-5 text-center mx-auto">
						<p>
							<span class="rank">レディースG2 優勝</span>
							<img
								src="/images/jdo/2026/masters/jdomasters_01.jpg"
								class="img-fluid"
							/>
							<span class="name">全 恵美</span>
						</p>
					</div>
				</div>
			</div>

			<div id="20260712_tokyo" class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>2026.7.12 ATDO DARTS TOURNAMENT 2026</h4>
				</div>
				<div class="row mb-4">
					<div class="col-lg-4 text-center offset-lg-2">
						<p>
							<span class="rank">メンズシングルス 優勝</span>
							<img
								src="/images/jdo/2026/tokyo/tokyo_01.jpg"
								class="img-fluid"
							/>
							<span class="name">大達 浩司</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">レディースシングルス 準優勝</span>
							<img
								src="/images/jdo/2026/tokyo/tokyo_02.jpg"
								class="img-fluid"
							/>
							<span class="name">青木 まゆ</span>
						</p>
					</div>
				</div>
			</div>

			<div id="20260517_ehime" class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>2026.5.17 OPEN DARTS TOURNAMENT IN EHIME 2026</h4>
				</div>
				<div class="row mb-4">
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">オープンダブルス 優勝</span>
							<img
								src="/images/jdo/2026/ehime/ehime_01.jpg"
								class="img-fluid"
							/>
							<span class="name">高山 得溶・大本 直樹</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">レディースシングルス 優勝</span>
							<img
								src="/images/jdo/2026/ehime/ehime_03.jpg"
								class="img-fluid"
							/>
							<span class="name">青木 まゆ</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">メンズシングルス 3位タイ</span>
							<img
								src="/images/jdo/2026/ehime/ehime_02.jpg"
								class="img-fluid"
							/>
							<span class="name">高山 得溶</span>
						</p>
					</div>
				</div>
			</div>

			<div id="20260419_kochi" class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>2026.04.19 KOCHI OPEN DARTS TOURNAMENT vol.16</h4>
				</div>
				<div class="col-12 mb-4 row">
					<div class="col-lg-5 text-center mx-auto">
						<p>
							<span class="rank">メンズシングルス 準優勝</span>
							<img
								src="/images/jdo/2026/kochi/kochi_01.jpg"
								class="img-fluid"
							/>
							<span class="name">高山 得溶</span>
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import SubHeader from "@/components/common/SubHeader.vue";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
	name: "tournament2020",
	components: {
		SubHeader,
	},
	data() {
		return {};
	},
	mounted: function () {},
	methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h2 {
	font-size: 1.6rem;
	margin-bottom: 1rem;
}
h4 {
	border-bottom: solid 3px #333;
	padding-bottom: 5px;
	margin-bottom: 2rem;
	position: relative;
	&:before {
		content: "";
		width: 3rem;
		height: 3px;
		background-color: $primary-color;
		display: block;
		position: absolute;
		left: 0;
		bottom: -3px;
	}
}
a {
	text-decoration: underline;
}
.container {
	padding: 4rem 1rem;
	text-align: left;
}
.btn-download {
	font-size: 1rem;
	color: #333;
	border: none;
	margin-top: 1rem;
	background: $primary-color;
	text-decoration: none;
	cursor: pointer;
	&:hover {
		color: #333;
		background-color: $secondary-color;
	}
	&:active {
		color: #333;
		background-color: $secondary-color;
	}
}
.rank,
.rank_winner,
.rank_2nd,
.rank_3rd,
.name {
	color: #333;
}
.rank_winner {
	font-size: 2rem;
	i {
		color: #dbb400;
	}
}
.rank_2nd {
	font-size: 1.4rem;
	i {
		color: #9fa0a0;
	}
}
.rank_3rd {
	font-size: 1.4rem;
	i {
		color: #c47022;
	}
}
i {
	margin-right: 0.6rem;
}
</style>
